import { WhiteLabelConfig } from '@allesauto/core/whiteLabel';

/**
 * Hook that returns the script for Matomo Tag Manager, which has to be included
 * on the <head> of the application
 */
export const useMTM = (isWhiteLabel: WhiteLabelConfig | undefined) => {
  // MTM script codes
  const containerCode = isWhiteLabel ? 'OLmZmC85' : 'X2Co4WNP';

  const MatomoScript = `var _mtm = window._mtm = window._mtm || [];
  _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
  var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
  g.async=true; g.src='https://stats.alles.auto/js/container_${containerCode}.js'; s.parentNode.insertBefore(g,s);`;

  return MatomoScript;
};
